import axios from "axios";
import { endPoint, endPointV1 } from "../ds";
import { rql } from "javascript-rql";

export async function apiGetRQL(params) {
  try {
    let url = endPointV1(params);

    // build RQL query string
    let rqlString = "";
    if (Object.keys(params.filter).length > 0) {
      let pos = 0;
      let maxPos = Object.keys(params.filter).length;

      Object.entries(params.filter).forEach(([key, value]) => {
        if (pos === 0) rqlString += "?";
        if (pos > 0 && pos < maxPos) rqlString += "&";
        if (value.style === "function") {
          rqlString += `${value.operator}(${key},${value.term})`;
        }
        if (value.style === "multiFunction") {
          rqlString += `${value.operator}(${value.term})`;
        }
        if (value.style === "query") {
          rqlString += `${key}${value.operator}${value.term}`;
        }
        if (value.style === "sort") {
          rqlString += `${key}(${value.term})`;
        }
        pos++;
      });
      url += `${rqlString}`;
    }

    const response = await axios.get(url);

    if (response.status === 200) {
      //console.log(`API Response from ${endpoint}:`, response);
      return response;
    } else {
      console.error(`Unexpected response status: ${response.status}`);
      return response;
    }
  } catch (response) {
    console.error(`Error from ${params.endpoint}:`, response.error);
    return response;
  }
}

export async function apiGet(endpoint, params = [], id = "") {
  try {
    const url = endPoint(endpoint, params, id);
    const response = await axios.get(url);

    if (response.status === 200) {
      //console.log(`API Response from ${endpoint}:`, response);
      return response;
    } else {
      console.error(`Unexpected response status: ${response.status}`);
      return response;
    }
  } catch (response) {
    console.error(`Error from ${endpoint}:`, response);
    return response;
  }
}

export async function apiPost(endpoint, payload, urlParams = []) {
  try {
    const url = endPoint(endpoint, urlParams);

    const response = await axios.post(url, payload);

    if (response.status === 200 || response.status === 201) {
      //console.log(`API Response from ${endpoint}:`, response);
      return response;
    } else {
      console.error(`Unexpected response status: ${response.status}`);
      return response;
    }
  } catch (response) {
    console.error(`Error from ${endpoint}:`, response);
    return response;
  }
}

export async function apiPatch(endpoint, id, payload = null, urlParams = []) {
  try {
    const url = endPoint(endpoint, urlParams, id);

    const response = await axios.patch(url, payload);

    if (response.status === 200 || response.status === 201) {
      //console.log(`API Response from ${endpoint}:`, response);
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.error(`Error from ${endpoint}:`, error);
    return error.response.data;
  }
}

export async function apiDelete(endpoint, id, urlParams = []) {
  try {
    const url = endPoint(endpoint, urlParams, id);

    const response = await axios.delete(url);

    if (response.status === 200) {
      //console.log(`API Response from ${endpoint}:`, response);
      return response;
    } else {
      console.error(`Unexpected response status: ${response.status}`);
      return response;
    }
  } catch (response) {
    console.error(`Error from ${endpoint}:`, response);
    return response;
  }
}

export async function apiGetDirectUrl(url) {
  try {
    const response = await axios.get(url);

    if (response.status === 200) {
      return response;
    } else {
      console.error(`Unexpected response status: ${response.status}`);
      return response;
    }
  } catch (response) {
    console.error(`Error from direct URL:`, response);
    return response;
  }
}
